import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const WHEEL_SIDE_FOR_SURE = {
  YES: 'yes',
  NO: 'no',
  IDK: 'does_not_know',
} as const;

export const WHEEL_SIDE_FACTORY_INSTALLED = 'wheel_side_factory_installed';
export const WHEEL_SIDE_FACTORY_INSTALLED_COMPLEMENTARY =
  'wheel_side_factory_installed_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupWheelSideForSure: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? WHEEL_SIDE_FACTORY_INSTALLED_COMPLEMENTARY
      : WHEEL_SIDE_FACTORY_INSTALLED);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy kierownica fabrycznie znajdowała się po lewej stronie?'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-wheel-side-for-sure"
            >
              <RadioItem
                value={WHEEL_SIDE_FOR_SURE.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-wheel-side-for-sure-yes"
              />
              <RadioItem
                value={WHEEL_SIDE_FOR_SURE.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-wheel-side-for-sure-no"
              />
              <RadioItem
                value={WHEEL_SIDE_FOR_SURE.IDK}
                label={i18n.t('Nie wiem')}
                data-testid="radio-item-wheel-side-for-sure-idk"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
